import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <SectionWrapper data-id="element-131">
      <div className="max-w-3xl mx-auto" data-id="element-132">
        <div className="bg-cyber-dark border border-gray-700 rounded-2xl p-8 md:p-10 relative overflow-hidden group hover:border-cyber-neon/50 transition-colors duration-500" data-id="element-133">
          {/* Subtle glow effect */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-1 bg-cyber-neon shadow-neon opacity-50 group-hover:opacity-100 transition-opacity" data-id="element-134"></div>

          <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-135">
            <div className="shrink-0" data-id="element-136">
              <div className="w-24 h-24 rounded-full bg-cyber-black border-2 border-cyber-neon flex items-center justify-center shadow-neon relative" data-id="element-137">
                <ShieldCheck className="w-12 h-12 text-cyber-neon" data-id="element-138" />
                {/* Rotating dashed border */}
                <div className="absolute inset-[-4px] border border-dashed border-cyber-neon/50 rounded-full animate-[spin_10s_linear_infinite]" data-id="element-139"></div>
              </div>
            </div>

            <div className="text-center md:text-left" data-id="element-140">
              <h3 className="text-2xl text-white font-mono font-bold mb-4" data-id="element-141">
                Garantía de "Cero Riesgo" de 7 Días
              </h3>
              <p className="text-gray-300 leading-relaxed" data-id="element-142">
                Si aplicas el protocolo por una semana y no sientes que tu
                confianza ha subido al menos un 50%, envíanos un email y te
                devolvemos el 100% de tu dinero.{' '}
                <strong className="text-white" data-id="element-143">
                  Sin preguntas, sin resentimientos.
                </strong>{' '}
                El riesgo está todo de mi lado.
              </p>
            </div>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}